import { apiDelete, apiGet, apiPatch, apiPost } from '../../../shared/api-client/index.js';
import { entityListKey, type EntityListKey } from '../../../shared/api/entityQueryKeys.js';

export interface TemplateItem {
  id: string;
  workspaceId: string;
  name: string;
  type: 'email' | 'sms' | 'in_app';
  subject?: string | null;
  body: string;
  variables: string[];
  isActive: boolean;
  usageCount: number;
  createdAt: string;
}

export interface ListTemplatesFilters {
  channel?: 'email' | 'sms' | 'in_app';
}

export interface UpdateTemplateInput {
  body?: string;
  subject?: string | null;
}

export interface CreateTemplateInput {
  name: string;
  type: 'email' | 'sms' | 'in_app';
  body: string;
  subject?: string | null;
}

export function getTemplatesQueryKey(
  workspaceId: string,
  filters: ListTemplatesFilters = {},
): EntityListKey {
  return entityListKey('templates', workspaceId, { ...filters });
}

export async function listTemplates(filters: ListTemplatesFilters = {}): Promise<TemplateItem[]> {
  const search = new URLSearchParams();
  if (filters.channel) {
    search.set('channel', filters.channel);
  }
  const path = search.size > 0 ? `/templates?${search.toString()}` : '/templates';
  return apiGet<TemplateItem[]>(path);
}

export async function updateTemplate(
  templateId: string,
  input: UpdateTemplateInput,
): Promise<TemplateItem> {
  return apiPatch<TemplateItem, UpdateTemplateInput>(`/templates/${templateId}`, input);
}

export async function createTemplate(input: CreateTemplateInput): Promise<TemplateItem> {
  return apiPost<TemplateItem, CreateTemplateInput>('/templates', input);
}

export async function deleteTemplate(templateId: string): Promise<void> {
  await apiDelete<void>(`/templates/${templateId}`);
}
